import { render } from "./Get-content-block.vue?vue&type=template&id=496bf110&scoped=true"
import script from "./Get-content-block.vue?vue&type=script&lang=js"
export * from "./Get-content-block.vue?vue&type=script&lang=js"

import "./styles.scss?vue&type=style&index=0&id=496bf110&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496bf110"]])

export default __exports__